@let limitViola = limitViolation();
<notifications-notification-item
  [message]="message()"
  [subjectTemplate]="subjectTemplate"
  [bodyTemplate]="bodyTemplate"
></notifications-notification-item>

<ng-template #subjectTemplate let-message>
  <!-- Custom subject template -->
  <span>
    {{ 'user-limit.notification.userlimitviolation.VIOLATION' | transloco }}
  </span>
  -
  <span>
    <span>{{ limitViola.userLimit.caption }}</span>
  </span>
</ng-template>

<ng-template #bodyTemplate let-message>
  @if (!limitViola) {
    <div>MISSING LIMIT VIOLATION</div>
  } @else {
    <div
      class="flex flex-row items-center w-full text-base cursor-pointer"
      [routerLink]="['/limits/preview/', limitViola.userLimit.id]"
    >
      <div
        class="icon spacer"
        matTooltip="{{
          'user-limit.notification.userlimitviolation.TITLE' | transloco
        }}"
      >
        <fa-icon [icon]="faBoltSlash" class=""></fa-icon>
      </div>
      <div class="flex flex-col w-full overflow-hidden">
        <div>
          <span class="italic">
            {{
              'user-limit.notification.userlimitviolation.SIGNALDATE'
                | transloco
            }}:
          </span>
          <span>{{ limitViola.signalDate | date: 'mediumDate' }}</span>
        </div>

        <div>
          <span class="italic">
            {{
              'user-limit.notification.userlimitviolation.EXPRESSION'
                | transloco
            }}:
          </span>
          <span>{{ limitViola.expression }}</span>
        </div>

        <div>
          <span class="italic">
            {{
              'user-limit.notification.userlimitviolation.RESOLVED_EXPRESSION'
                | transloco
            }}:
          </span>
          <span>{{ limitViola.resolvedExpression }}</span>
        </div>
      </div>
    </div>
  }
</ng-template>
